import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

// Captures the contact name + number required to confirm a transport group from
// the Transfers view, then hands them back to the caller (which saves the
// contact and confirms). Keeps confirmation consistent with the Transport board,
// where contact details are mandatory.
export default function ConfirmContactDialog({ open, group, onClose, onConfirm }) {
  const [contactName, setContactName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setContactName(group?.contactName || "");
    setContactNumber(group?.contactNumber || "");
    setSaving(false);
  }, [open, group]);

  const canConfirm =
    contactName.trim() !== "" && contactNumber.trim() !== "" && !saving;

  const handleConfirm = async () => {
    if (!canConfirm) return;
    setSaving(true);
    try {
      await onConfirm?.({
        contactName: contactName.trim(),
        contactNumber: contactNumber.trim(),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Confirm {group?.groupName || "transport group"}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ opacity: 0.75 }}>
            A contact name and number are required to confirm this bus.
          </Typography>
          <TextField
            label="Contact name"
            value={contactName}
            onChange={(e) => setContactName(e.target.value)}
            fullWidth
            autoFocus
          />
          <TextField
            label="Contact number"
            value={contactNumber}
            onChange={(e) => setContactNumber(e.target.value)}
            fullWidth
          />
          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            You will be recorded as the person who confirmed this transport group.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleConfirm} disabled={!canConfirm}>
          Save &amp; confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
